<template>
  <div class="img-splitter">
    <!-- 广告位 -->
    <ad-top></ad-top>
    <!-- 简介 -->
    <el-row type="flex" justify="center">
      <el-col :md="20">
        <div class="intro-detail">
          {{ $t('tools.imgSplitter.introduction') }}
          <!-- <el-link type="primary" href="" target="_blank">Learn more!</el-link> -->
        </div>
      </el-col>
    </el-row>
    <el-row>
        <!-- 图片区 -->
        <el-col :md="{span: 10, offset: 2}">
            <canvas id="splitter" ref="splitter"></canvas>
            <div v-show="data.loaded" class="img-box-wrapper">
                <img id="img-box" ref="sourceImg" :alt="data.name" :src="data.url" @load="imgLoad">
                <canvas id="split-box" ref="splitBox" :style="splitBox.style" 
                @mousedown="splitBoxMouseDown"
                @mousemove="splitBoxMouseMove"
                @mouseup="splitBoxMouseUp"></canvas>
            </div>
            <div v-show="!data.loaded" class="img-box-wrapper"> 
              <img-loader :data="data"></img-loader>
            </div>
        </el-col>
        <!-- 配置区 -->
        <el-col :md="12">
          <!-- 行配置 -->
          <el-row>
            <el-col :md="{span: 12, offset: 5}">
              <el-divider class="config-divider" content-position="left"> {{ $t('tools.imgSplitter.row') }}</el-divider>
            </el-col>
          </el-row>
          <el-row>
            <el-col :xs="3" :sm="3" :md="8">
              <el-button class="btn-minus" type="primary" icon="el-icon-minus" circle @click="minus('row')" :disabled=config.rowMinusBtnDisabled></el-button>
            </el-col> 
            <el-col :xs="18" :sm="18" :md="6">
              <span class="num-input">{{ config.row }}</span>
            </el-col>  
            <el-col :xs="3" :sm="3" :md="8">
              <el-button class="btn-plus" type="primary" icon="el-icon-plus" circle @click="plus('row')"></el-button>
            </el-col> 
          </el-row>
          <!-- 列配置 -->
          <el-row>
            <el-col :md="{span: 12, offset: 5}">
              <el-divider class="config-divider" content-position="left">{{ $t('tools.imgSplitter.column') }}</el-divider>
            </el-col>
          </el-row>
          <el-row>
            <el-col :xs="3" :sm="3" :md="8">
              <el-button class="btn-minus" type="primary" icon="el-icon-minus" circle @click="minus('col')" :disabled=config.colMinusBtnDisabled></el-button>
            </el-col> 
            <el-col :xs="18" :sm="18" :md="6">
              <span class="num-input">{{ config.col }}</span>
            </el-col>  
            <el-col :xs="3" :sm="3" :md="8">
              <el-button class="btn-plus" type="primary" icon="el-icon-plus" circle @click="plus('col')"></el-button>
            </el-col> 
          </el-row>
          <!-- 其他配置 -->
          <el-row>
            <el-col :md="{span: 12, offset: 5}">
              <el-divider class="config-divider" content-position="left">{{ $t('tools.imgSplitter.saveAs') }}</el-divider>
            </el-col>
          </el-row>
          <el-row>
            <el-col :md="{span: 12, offset: 6}" :sm="{span: 18, offset: 4}" :xs="{span: 18, offset: 4}">
              <el-select class="config-select" v-model="config.saveType.type" @change="changeSaveTypes">
                <el-option v-for="item in saveTypes" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-col>
          </el-row>
          <!-- 导入图片 -->
          <el-row>
            <el-col :md="{span: 12, offset: 5}">
              <el-divider class="config-divider"></el-divider>
            </el-col>
          </el-row>
          <el-row>
            <el-col :md="{span: 12, offset: 6}" :sm="{span: 18, offset: 4}" :xs="{span: 18, offset: 4}">
              <el-button class="config-big-btn first" type="primary" icon="el-icon-upload" @click="importImg" round>{{ $t('tools.imgSplitter.importImg') }}</el-button>
            </el-col>
          </el-row>
          <!-- 切割图片 -->
          <el-row>
            <el-col :md="{span: 12, offset: 6}" :sm="{span: 18, offset: 4}" :xs="{span: 18, offset: 4}">
              <el-button class="config-big-btn" type="primary" icon="el-icon-scissors" @click="splitImg" round :disabled="config.isDrawing || config.isSplitting">{{ $t('tools.imgSplitter.splitImg') }}</el-button>
            </el-col>
          </el-row>
          <!-- 动森工具引导 -->
          <el-row>
            <el-col :md="{span: 12, offset: 6}" :sm="{span: 18, offset: 4}" :xs="{span: 18, offset: 4}">
              <el-button class="config-big-btn" type="success" @click="gotoAcnlTool" round>{{ $t('tools.imgSplitter.toAcnlTool') }}</el-button>
            </el-col>
          </el-row>
        </el-col>
    </el-row>
    <!-- 广告位 -->
    <ad-bottom></ad-bottom>
  </div>
</template>

<script>
import adTop from '../../components/ad/ad-top'
import adBottom from '../../components/ad/ad-bottom'
import imgLoader from '../../components/img-loader'
import { saveAs } from 'file-saver'
import JSZip from 'jszip'

export default {
    name: "img-splitter",
    data() {
        return {
          splitter2d: new Object(),
          splitBox2d: new Object(),
          data: {
            splitted: false,
            splitting: false,
            loaded: false,
            name: '',
            previousUrl: '',
            type: '',
            url: '',
          },
          config: {
            srcImg: {
              naturalWidth: 0, 
              naturalHeight: 0,
              displayWidth: 0,
              displayHeight: 0
            },
            block: {
              naturalWidth: 0, 
              naturalHeight: 0,
              displayWidth: 0,
              displayHeight: 0
            },
            row: 3,
            col: 3,
            saveType: {
              type: 'image/png',
              suffix: 'png'
            },
            scale: [1,1],
            rowMinusBtnDisabled: false,
            colMinusBtnDisabled: false,
            isSplitting: false,
            isDrawing: false
          },
          splitBox: {
            style: {
              top: '0px',
              left: '0px',
              display: 'none',
              cursor: 'default'
            }
          },
          gridBox: {
            startX: 0,
            startY: 0,
            width: 0,
            height: 0
          },
          zip: null,
          mouse: {
            x: 0,
            y: 0,
            moveable: false
          },
          saveTypes:[
            {
              label: 'PNG',
              value: 'image/png'
            },
            {
              label: 'JPG',
              value: 'image/jpeg'
            },
            {
              label: 'GIF',
              value: 'image/gif'
            }
          ]
        }
    },
    components: {
        adTop,
        adBottom,
        imgLoader
    },
    methods: {
        init() {
            let splitter = this.$refs.splitter;
            this.splitter2d = splitter.getContext("2d");
        },
        imgLoad() {
          this.config.isDrawing = true;
          // 读取切分配置
          // 给图像增加一层网格
          let splitBox = this.$refs.splitBox;
          let width = this.$refs.sourceImg.offsetWidth;
          let height = this.$refs.sourceImg.offsetHeight;
          let top = this.$refs.sourceImg.offsetTop;
          let left = this.$refs.sourceImg.offsetLeft;
          
          this.splitBox.style.top = top + 'px';
          this.splitBox.style.left = left + 'px';
          this.splitBox.style.display = 'block';

          this.gridBox.startX = 0;
          this.gridBox.startY = 0;

          // 设置图像宽高
          this.config.srcImg.naturalWidth = this.$refs.sourceImg.naturalWidth;
          this.config.srcImg.naturalHeight = this.$refs.sourceImg.naturalHeight;
          this.config.srcImg.displayWidth = width;
          this.config.srcImg.displayHeight = height;

          this.splitBox2d = splitBox.getContext("2d");

          // 加载网格层
          this.loadGrid();

          this.config.isDrawing = false;
        },
        loadGrid() {
          // 设置网格canvas宽高，也可起到重置画布作用
          let splitBox = this.$refs.splitBox;
          let width = this.$refs.sourceImg.offsetWidth;
          let height = this.$refs.sourceImg.offsetHeight;
          splitBox.width = width;
          splitBox.height = height;
          // 计算网格宽高
          this.calcGrid();

          // 绘制阴影
          this.drawShadow();

          // 绘制网格
          this.drawGrid();
        },
        reloadGrid() {
          // 设置网格canvas宽高，也可起到重置画布作用
          let splitBox = this.$refs.splitBox;
          let width = this.$refs.sourceImg.offsetWidth;
          let height = this.$refs.sourceImg.offsetHeight;
          splitBox.width = width;
          splitBox.height = height;

          // 绘制阴影
          this.drawShadow();

          // 绘制网格
          this.drawGrid();
        },
        calcGrid() {
          // 计算显示网格数据
          let imgWidth = this.config.srcImg.displayWidth;
          let imgHeight = this.config.srcImg.displayHeight;
          
          // 按所选比例对图片尺寸进行修正
          const widthScale = this.config.scale[0];
          const heightScale = this.config.scale[1];
         
          // 计算分块的宽度
          let  blockWidth = imgWidth / this.config.col;
          // 计算分块的高度
          let  blockHeight = imgHeight / this.config.row;
          // 分块实际宽度
          let blockNaturalWidth = 0;
          // 分块实际高度
          let blockNaturalHeight = 0;
          if (widthScale > 0 && heightScale > 0) {
            
            const configScale = widthScale / heightScale;
            const calcScale = blockWidth / blockHeight;

            if (configScale > calcScale) {
              // 配置比例高度大于实际比例高度
              // 以实际比例宽度重新计算高度
              blockHeight = blockWidth / widthScale * heightScale;
              // 以图像实际宽度计算分块实际宽高
              blockNaturalWidth = this.config.srcImg.naturalWidth / this.config.col;
              blockNaturalHeight = (this.config.srcImg.naturalWidth * heightScale) / (this.config.col * widthScale);
            } else {
              // 配置比例宽度大于实际比例宽度
              // 以实际比例高度重新计算宽度
              blockWidth = blockHeight / heightScale * widthScale;
              // 以图像实际高度计算分块实际宽高
              blockNaturalWidth = (this.config.srcImg.naturalHeight * widthScale) / (this.config.row * heightScale);
              blockNaturalHeight = this.config.srcImg.naturalHeight / this.config.row;
            }
            
          }

          this.config.block.displayWidth = blockWidth;
          this.config.block.displayHeight = blockHeight;

          this.config.block.naturalWidth = blockNaturalWidth;
          this.config.block.naturalHeight = blockNaturalHeight;
          
          this.gridBox.width = blockWidth * this.config.col;
          this.gridBox.height = blockHeight * this.config.row;

        },
        drawGrid() {
          // 绘制网格线
          // 绘制横线
          const row = this.config.row;
          const col = this.config.col;
          const blockDisplayWidth = this.config.block.displayWidth;
          const blockDisplayHeight = this.config.block.displayHeight
          if (row > 0) {
            for (let index = 1; index < row; index++) {
              let startX = this.gridBox.startX;
              let startY = blockDisplayHeight * index + this.gridBox.startY;
              let finshX = this.gridBox.width + startX;
              let finshY = startY;
              this.drawLine(startX, startY, finshX, finshY);
            }
          }
          // 绘制竖线
          if (col > 0) {
            for (let index = 1; index < col; index++) {
              let startX = blockDisplayWidth * index + this.gridBox.startX;
              let startY = this.gridBox.startY;
              let finshX = startX;
              let finshY = this.gridBox.height + startY;
              this.drawLine(startX, startY, finshX, finshY);
            }
          }
        },
        drawLine(startX, startY, finshX, finshY, color, lineWidth) {
          this.splitBox2d.beginPath();
          if (!color) {
            color = '#999';
          }
          if (lineWidth) {
            this.splitBox2d.lineWidth = lineWidth;
          }
          this.splitBox2d.strokeStyle = color;
          this.splitBox2d.moveTo(startX, startY);
          this.splitBox2d.lineTo(finshX, finshY);
          this.splitBox2d.stroke();
        },
        drawShadow() {
          
          // 网格区域宽高
          const gridDisplayWidth = this.gridBox.width;
          const gridDisplayHeight = this.gridBox.height;
          
          this.splitBox2d.beginPath();
          this.splitBox2d.fillStyle = "rgba(153, 153, 153, 0.6)";
          this.splitBox2d.fillRect(0, 0, this.$refs.splitBox.width, this.$refs.splitBox.height);
          this.splitBox2d.clearRect(this.gridBox.startX, this.gridBox.startY, gridDisplayWidth, gridDisplayHeight);
          this.splitBox2d.strokeStyle = '#999';
          this.splitBox2d.strokeRect(this.gridBox.startX, this.gridBox.startY, gridDisplayWidth, gridDisplayHeight);

        },
        minus(tag) {
          let value = 0;
          if (tag === 'row') {
            value = this.config.row;
          } else if(tag === 'col') {
            value = this.config.col;
          } else {
            return;
          }

          if (value <= 1) {
            return;
          }

          value = value - 1;
          if (tag === 'row') {
            this.config.row = value;
            if (value === 1) {
              this.config.rowMinusBtnDisabled = true;
            }
          } else if(tag === 'col') {
            this.config.col = value;
            if (value === 1) {
              this.config.colMinusBtnDisabled = true;
            }
          }

          // 加载网格层
          this.loadGrid();
        },
        plus(tag) {
          let value = 0;
          if (tag === 'row') {
            value = this.config.row;
          } else if(tag === 'col') {
            value = this.config.col;
          } else {
            return;
          }

          value = value + 1;
          if (tag === 'row') {
            this.config.row = value;
            if (value > 1) {
              this.config.rowMinusBtnDisabled = false;
            }
          } else if(tag === 'col') {
            this.config.col = value;
            if (value >= 1) {
              this.config.colMinusBtnDisabled = false;
            }
          }
          // 加载网格层
          this.loadGrid();
        },
        importImg() {
          document.getElementById('file').click();
        },
        async splitImg() {
          this.config.isSplitting = true;
          // 网格偏移量
          let gridBoxStartX = this.gridBox.startX;
          let gridBoxStartY = this.gridBox.startY;

          let offsetX = (gridBoxStartX * this.config.srcImg.naturalWidth) / this.config.srcImg.displayWidth;
          let offsetY = (gridBoxStartY * this.config.srcImg.naturalHeight) / this.config.srcImg.displayHeight;

          // 切割图片
          this.zip = new JSZip();
          const blockCount = this.config.row * this.config.col;
          const blockWidth = this.config.block.naturalWidth;
          const blockHeight = this.config.block.naturalHeight;
          for (let index = 0; index < blockCount; index++) {
            let startX = offsetX + index % this.config.col * blockWidth;
            let startY = offsetY + parseInt(index / this.config.row) * blockHeight;
            await this.splitToBlock(index + 1, startX, startY, blockWidth, blockHeight);
          }
          
          this.zip.generateAsync({type:"blob"}).then((content) => {
              // see FileSaver.js
              saveAs(content, "g-lab-img-split.zip");
              this.config.isSplitting = false;
          });

        },
        splitToBlock(index, startX, startY, width, height) {
          // 设置canvas宽高，可起到重置画布作用
          this.$refs.splitter.width = this.config.block.naturalWidth;
          this.$refs.splitter.height = this.config.block.naturalHeight;
          // 裁剪图片
          this.splitter2d.drawImage(this.$refs.sourceImg, startX, startY, width, height, 0, 0, width, height);
          
          return new Promise((resolve, reject) => {
            try {
              // 保存
              // 将每次不同的canvas数据添加到zip文件中
              this.$refs.splitter.toBlob((blob) => {
                this.zip.file(index + '.' + this.config.saveType.suffix, blob, {base64: true});
                resolve();
              }, this.config.saveType.type);
            } catch (error) {
              reject();
            }
          })
        },
        changeSaveTypes(data) {
          let suffix = 'png';
          if ('image/jpeg' === data) {
            suffix = 'jpg';
          } else if ('image/gif' === data) {
            suffix = 'gif';
          }
          
          this.config.saveType.suffix = suffix;
        },
        splitBoxMouseDown(mouse) {
          // 记录鼠标位置
          this.mouse.x = mouse.layerX;
          this.mouse.y = mouse.layerY;

          // 判断鼠标是否在网格框内
          // 不在则标记移动无效
          if (this.isMouseInSplitBox(mouse)) {
            this.mouse.moveable = true;
          } else {
            this.mouse.moveable = false;
          }
        },
        splitBoxMouseMove(mouse) {

          if (this.isMouseInSplitBox(mouse)) {
            this.splitBox.style.cursor = 'move';
          } else {
            this.splitBox.style.cursor = 'default';
          }

          if (this.mouse.moveable) {
            // 本次鼠标位置与上次鼠标位置进行偏移量计算
            let offsetX = mouse.layerX - this.mouse.x;
            let offsetY = mouse.layerY - this.mouse.y;

            // 计算网格重绘初始位置
            let gridBoxStartX = this.gridBox.startX + offsetX;
            let gridBoxStartY = this.gridBox.startY + offsetY;

            // 如果移动后的位置超过splitBox
            // 认为是无效移动
            let splitBoxWidth = this.$refs.splitBox.width;
            let splitBoxHeight = this.$refs.splitBox.height;
            let calcGridWidth = gridBoxStartX + this.gridBox.width;
            let calcGridHeight = gridBoxStartY + this.gridBox.height;

            let toRedraw = true;
            if (calcGridWidth > splitBoxWidth) {
              // 宽度有超出部分，重新计算偏移量
              gridBoxStartX -= calcGridWidth - splitBoxWidth;
            } else if (gridBoxStartX < 0) {
              // 计算后网格X坐标起始位置小于0
              // 修正位0
              gridBoxStartX = 0;
            }

            if (calcGridHeight > splitBoxHeight) {
              // 高度有超出部分，重新计算偏移量
              gridBoxStartY -= calcGridHeight - splitBoxHeight;
            } else if (gridBoxStartY < 0) {
              // 计算后网格Y坐标起始位置小于0
              // 修正位0
              gridBoxStartY = 0;
            }

            if (gridBoxStartX === this.gridBox.startX && gridBoxStartY === this.gridBox.startY) {
              // 重新计算后位置与上一次位置一致
              // 不重新绘制网格
              toRedraw = false;
            }

            if (toRedraw) {
              this.gridBox.startX = gridBoxStartX;
              this.gridBox.startY = gridBoxStartY;

              // 重绘网格
              this.reloadGrid();
  
              // 记录本次鼠标位置
              this.mouse.x = mouse.layerX;
              this.mouse.y = mouse.layerY;
            }

          }
        },
        splitBoxMouseUp() {
          this.mouse.moveable = false;
        },
        isMouseInSplitBox(mouse) {
          this.splitBox2d.beginPath();
          let startX = this.gridBox.startX;
          let startY = this.gridBox.startY;
          let width = this.gridBox.width;
          let height = this.gridBox.height;
          this.splitBox2d.rect(startX, startY, width, height);
          return this.splitBox2d.isPointInPath(mouse.layerX, mouse.layerY);
        },
        gotoAcnlTool() {
          window.open('https://acpatterns.com/editor');
        }
    },
    mounted() {
        this.init();
    }
}
</script>

<style scoped>
#splitter {
  display: none;
}
.img-box-wrapper {
  width: 100%;
  height: 30em;
  line-height: 30em;
  text-align: center;
  vertical-align: middle;
}
#img-box {
  max-width: 100%;
  height: 100%;
}
#split-box {
  position: absolute;
  border: 1px dashed #999;
  z-index: 999;
}
.btn-minus {
  float:right;
  margin-right: 1em;
}
.btn-plus {
  margin-left: 1em;
}
.num-input {
  width: 100%;
  line-height: 38px;
  text-align: center;
  vertical-align: middle;
  display:inline-block;
  border: 1px solid #2ECC71;
  border-radius:20px;
  -moz-border-radius:20px; /* Old Firefox */
  background-color: #2ECC71;
  font-size: 1.5em;
  color: #FFFFFF;
}
.config-divider {
  width: 95%;
}
.config-select {
  width: 85%;
}
.config-big-btn {
  width: 85%;
  font-size: 1.5em;
  border-radius:30px;
  -moz-border-radius:30px; /* Old Firefox */
}
.config-big-btn:not(.first) {
  margin-top: 20px;
}
</style>